import { Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { GridType, GRID_TYPE_TOKEN, REGISTRY_PATH, REGISTRY_PATH_COLOR, REGISTRY_PATH_TOKEN } from './app.const';
import { ImageStateService } from './image-state/image-state.service';
import { galleryUrlMatcher } from './gallery-url/gallery-url.matcher';

export const routes: Routes = [
  { path: '', component: LandingPageComponent },
  {
    path: GridType.monochrome,
    loadComponent: () => import('./grid/grid.component').then(m => m.GridComponent),
    providers: [
      { provide: GRID_TYPE_TOKEN, useValue: GridType.monochrome },
      { provide: REGISTRY_PATH_TOKEN, useValue: REGISTRY_PATH },
      ImageStateService,
    ],
    children: [
      {
        matcher: galleryUrlMatcher,
        loadComponent: () => import('./gallery-item/gallery-item.component').then(m => m.GalleryItemComponent),
      },
    ],
  },
  {
    path: GridType.color,
    loadComponent: () => import('./grid/grid.component').then(m => m.GridComponent),
    providers: [
      { provide: GRID_TYPE_TOKEN, useValue: GridType.color },
      { provide: REGISTRY_PATH_TOKEN, useValue: REGISTRY_PATH_COLOR },
      ImageStateService,
    ],
    children: [
      {
        matcher: galleryUrlMatcher,
        loadComponent: () => import('./gallery-item/gallery-item.component').then(m => m.GalleryItemComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
